import "./portfolio.css";

// import { Link } from "react-router-dom";

function Portfolio() {
  return (
    <div>
      <section>
        <div className="container">
          <div className="row port">
            <div className="col-md-3">
              <div className="work">
                <a
                  href="https://www.figma.com/proto/thILexJZiEWC5LRWCHX6Su/FitCodeAcademy?node-id=1%3A2&scaling=min-zoom&page-id=0%3A1"
                  target="_blank" rel="noreferrer"
                >
                  <h4 className="line">FitCode Institute</h4>
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div className="work">
              <a
                  href="https://www.figma.com/file/qZYMRE6mr2F2oHDHNoOvzs/Banking?node-id=0%3A1"
                  target="_blank" rel="noreferrer"
                >
                  <h4 className="line">Smart Bank</h4>
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div className="work">
              <a
                  href="https://www.figma.com/file/sK4QaZkkbAaXO58wT0tHfk/Primhex-team-library?node-id=312%3A25488"
                  target="_blank" rel="noreferrer"
                >
                  <h4 className="line">Primhex Project</h4>
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div className="work">
              <a
                  href="https://www.figma.com/file/WF3qbvFAcBFxVjHmFLyLyv/mini-project?node-id=0%3A1"
                  target="_blank" rel="noreferrer"
                >
                  <h4 className="line">Brainy Digital Agency</h4>
                </a>
              </div>
            </div>
          </div>
          <div className="row port">
            <div className="col-md-3">
              <div className="work">
              <a
                  href="https://www.figma.com/file/1tsAtT4XLMZZ0LyPMAwaYd/PLS-Express?node-id=190%3A139"
                  target="_blank" rel="noreferrer"
                >
                  <h4 className="line">PLS-Logistics</h4>
                </a>
              </div>
            </div>
            <div className="col-md-3">
            <div className="work">
            <a
                  href="https://www.figma.com/file/ZJFjTX0cRXQaPcpqme0O6l/KiddiesAcademy?node-id=0%3A1"
                  target="_blank" rel="noreferrer"
                >
                  <h4 className="line">KiddiesAcademy</h4>
                </a>
            </div>
            </div>

            <div className="col-md-3"></div>
            <div className="col-md-3"></div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Portfolio;
